module.exports = __webpack_public_path__ + "img/log_out.b8f08caf.svg";